const OFFERED_INSTRUMENTS = Object.freeze(['vocals', 'keyboard', 'guitar', 'drums']);

export default OFFERED_INSTRUMENTS;
